<template>
<div class="modal-mask-home background-dance">
    <div class="modal-wrapper-home">
        <div class="modal-container-home">
            <!-- <div class="close tamanhoicon" @click="$emit('settings')">
                 <img :src="require('@/assets/buttons/newbuttons/dance/settings.svg')" />
            </div>-->
            <div class="modal-header-home tamanhotitle">
                <slot name="header">
                   {{$t('menu.general.quit')}}
                </slot>
            </div>
            <div class="modal-body-home">
                <slot name="body">
                    <div class="tamanhoicon" @click="$emit('returnHome')">
                        <img :src="require('@/assets/buttons/newbuttons/general/submit.svg')" />
                    </div>
                    <div class="tamanhoicon" @click="$emit('closeModal')">
                        <img :src="require('@/assets/buttons/newbuttons/general/close.svg')" />
                    </div>

                </slot>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "FinalModal",
    emits: ['settings', 'returnHome','closeModal'],
    created() {},
    data() {
        return {};
    },
    props: {},
    methods: {},
};
</script>

<style>

.background-dance {
    background-color: rgba(178, 57, 8, 0.7);
}

</style>
